import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Context } from '@grandvisionhq/carts-v2';
import { toast } from '@grandvisionhq/common';
import { Types } from '@grandvisionhq/graphql';
import { useAdyen, PaymentMethod, PaymentServiceProvider, Hooks } from '@grandvisionhq/payments';
import { useIntl, useSelector, useDispatch } from '@grandvisionhq/state';
import { convertCentsToDecimalString } from '@grandvisionhq/utils';
import { updateCartState } from '../../../../actions.js';
import '@grandvisionhq/api-client';
import { resetExpressCheckout } from '../../../../StepShipping/actions.js';
import { getShippingDetails } from '../../../../StepShipping/selectors.js';
import '@grandvisionhq/auth';
import '../../../../context/CheckoutSettings/context.js';
import { getChangedOptIns } from '../../../../selectors.js';
import { useSetCustomerDetails } from '../../../../hooks/operations/use-set-customer-details.js';
import '@grandvisionhq/lib-utils-cart';
import { GooglePaySessionErrors } from '../../../../mappers/errors-mapping.js';
import '../../../../operations/mutations/set-customer-details.js';
import '../../../../operations/mutations/set-shipping-method.js';
import '../../../../operations/mutations/set-shipping-state.js';
import '../../../../operations/mutations/set-store.js';
import '../../../../operations/mutations/create-apple-pay-session.js';
import '../../../../operations/mutations/recreate-ordered-checkout.js';
import { getSelectedOptIns } from '../../../../utils/get-selected-opt-ins.js';
import 'lodash/isEmpty';
import '../../../../utils/get-customer-details-payload.js';
import '../../../../models/cart/cart-state.js';
import '../../../../models/checkout/checkout-step-error-type.js';
import '../../../../models/checkout-settings.js';
import { ShippingMethod } from '../../../../models/step-shipping/shipping-methods.js';
import '../../../../models/shared.js';
import 'history';
import '../../../../utils/has-cart-errors.js';
import { useCreateOrder } from '../../../../hooks/orders/use-create-order.js';
import { useCreateOrderDraft } from '../../../../hooks/orders/use-create-order-draft.js';
import { useRedirectToExpressCheckout } from '../../../../hooks/orders/use-redirect-to-express-checkout.js';
import { useRedirectToOrderComplete } from '../../../../hooks/orders/use-redirect-to-order-confirm-page.js';
import '../../../../operations/fragments/checkout-mutation-result.js';
import '../../../../operations/fragments/cart-mutation-failures.js';
import '../../../../operations/fragments/recreate-ordered-checkout-failure.js';
import '../../../../operations/fragments/recreate-ordered-checkout-result.js';
import '../../../../operations/fragments/paypal-payment.js';
import '../../../../operations/fragments/saved-user-details.js';
import '../../../../operations/queries/get-checkout-state.js';
import '../../../../operations/queries/get-user-details.js';
import { getBrowserInfo } from '../../../../StepPayment/utils/get-browser-info.js';
import { mapGooglePayContactAddress } from './mappers/google-pay-contact-address.js';
import { getDateOfBirth } from './mappers/google-pay-date-of-birth.js';
import { useMapShippingAddress } from './utility-hooks/use-map-shipping-address.js';
import { useValidatePaymentData } from './utility-hooks/use-validate-payment-data.js';

var UseGooglePayError;
(function(UseGooglePayError) {
    UseGooglePayError["UNSUPPORTED"] = "UNSUPPORTED";
    UseGooglePayError["CANCELLED"] = "CANCELLED";
    UseGooglePayError["FAILED"] = "FAILED";
    UseGooglePayError["INVALID_SHIPPING"] = "INVALID_SHIPPING";
})(UseGooglePayError || (UseGooglePayError = {}));
const useGooglePay = ({ returnPath  } = {})=>{
    const { locale , currency , country  } = useIntl();
    const redirectToOrderComplete = useRedirectToOrderComplete();
    const redirectToExpressCheckout = useRedirectToExpressCheckout();
    const [error1, setError] = React.useState();
    const shippingDetails = useSelector(getShippingDetails);
    const changedOptIns = useSelector(getChangedOptIns);
    const { cart  } = Context.useCart();
    const mapShippingAddress = useMapShippingAddress();
    const dispatch = useDispatch();
    const validatePaymentData = useValidatePaymentData();
    const createOrderDraft = useCreateOrderDraft();
    const [createOrder, { error: createOrderError , loading: createOrderLoading  }] = useCreateOrder({
        returnPath
    });
    const { AdyenModule , clientKey , environment  } = useAdyen();
    const shippingMethodRef = React.useRef(cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key);
    const onSetCustomerDetailsCompleted = React.useCallback(()=>{
        (cart === null || cart === void 0 ? void 0 : cart.checkoutState) && dispatch(updateCartState({
            cartState: cart === null || cart === void 0 ? void 0 : cart.checkoutState
        }));
    }, [
        cart === null || cart === void 0 ? void 0 : cart.checkoutState,
        dispatch
    ]);
    const { setCustomerDetails , updateError  } = useSetCustomerDetails({
        onCompleted: onSetCustomerDetailsCompleted
    });
    React.useEffect(()=>{
        shippingMethodRef.current = cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key;
    }, [
        cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key
    ]);
    const getCustomerDetails = React.useCallback((paymentData)=>{
        var ref, ref1, ref2, ref3, ref4;
        const dateOfBirth = getDateOfBirth(shippingDetails === null || shippingDetails === void 0 ? void 0 : shippingDetails.expressCheckout);
        const phone = (ref = paymentData.paymentMethodData.info) === null || ref === void 0 ? void 0 : (ref1 = ref.billingAddress) === null || ref1 === void 0 ? void 0 : ref1.phoneNumber;
        const vatId = shippingDetails === null || shippingDetails === void 0 ? void 0 : (ref2 = shippingDetails.expressCheckout) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.formData) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.customerVatId) === null || ref4 === void 0 ? void 0 : ref4.value;
        // Only for DK & SE add email optIn to cart as auth0 is not available
        let selectedOptIns = [];
        if (changedOptIns) {
            selectedOptIns = getSelectedOptIns(changedOptIns);
        }
        return swcHelpers.objectSpread({
            customerDetails: swcHelpers.objectSpread({
                customerType: Types.CheckoutCustomerType.B2C,
                email: paymentData.email
            }, dateOfBirth ? {
                dateOfBirth
            } : {}, phone ? {
                phone
            } : {}),
            billingAddress: mapGooglePayContactAddress(paymentData, 'billingAddress'),
            shippingAddress: mapShippingAddress(paymentData)
        }, vatId ? {
            invoiceDetails: {
                vatId
            }
        } : {}, {
            marketingEmailsOptIn: selectedOptIns.includes('marketingEmailsOptIn')
        });
    }, [
        changedOptIns,
        mapShippingAddress,
        shippingDetails === null || shippingDetails === void 0 ? void 0 : shippingDetails.expressCheckout
    ]);
    const options = React.useMemo(()=>({
            clientKey,
            environment,
            locale: `${locale}`
        })
    , [
        clientKey,
        environment,
        locale
    ]);
    const checkout = React.useMemo(()=>{
        const AdyenCheckout = AdyenModule === null || AdyenModule === void 0 ? void 0 : AdyenModule.result;
        return AdyenCheckout && AdyenCheckout(options);
    }, [
        AdyenModule,
        options
    ]);
    const onAuthorized = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(paymentData) {
            const { isPaymentDataValid , error  } = validatePaymentData(paymentData);
            if (!isPaymentDataValid && error) {
                setError(UseGooglePayError.INVALID_SHIPPING);
                toast.failed(error.message);
                return;
            }
            yield setCustomerDetails(getCustomerDetails(paymentData));
            if (updateError) {
                toast.failed('checkout.errors.general.message');
            } else {
                const googlePayToken = paymentData.paymentMethodData.tokenizationData.token;
                const createOrderDraftPayload = yield createOrderDraft({
                    paymentDetails: {
                        data: {
                            googlePayToken,
                            browserInfo: swcHelpers.objectSpread({}, getBrowserInfo())
                        },
                        isValid: true,
                        type: PaymentMethod.GOOGLE_PAY
                    },
                    selectedPaymentMethod: {
                        type: PaymentMethod.GOOGLE_PAY,
                        provider: PaymentServiceProvider.ADYEN
                    },
                    returnUrl: 'https://not-needed-but-required-by-adyen.com'
                });
                const orderResponse = yield createOrder(createOrderDraftPayload);
                dispatch(resetExpressCheckout());
                if (orderResponse === null || orderResponse === void 0 ? void 0 : orderResponse.success) {
                    redirectToOrderComplete({
                        cartId: (orderResponse === null || orderResponse === void 0 ? void 0 : orderResponse.cartId) || createOrderDraftPayload.checkoutId,
                        orderData: orderResponse === null || orderResponse === void 0 ? void 0 : orderResponse.orderDataToken,
                        expressOrder: true
                    });
                } else {
                    (orderResponse === null || orderResponse === void 0 ? void 0 : orderResponse.cartId) && redirectToExpressCheckout({
                        type: 'GOOGLE_PAY',
                        cartId: orderResponse.cartId
                    });
                }
            }
        });
        return function(paymentData) {
            return _ref.apply(this, arguments);
        };
    }(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        changedOptIns,
        shippingDetails
    ]);
    var ref5;
    const googlePayConfigProps = React.useMemo(()=>{
        return {
            locale,
            cartPrices: cart === null || cart === void 0 ? void 0 : cart.prices,
            lineItems: ((ref5 = cart === null || cart === void 0 ? void 0 : cart.lineItems) !== null && ref5 !== void 0 ? ref5 : []).map((lineItem)=>({
                    name: lineItem.name,
                    price: convertCentsToDecimalString(lineItem.price.unit.gross)
                })
            ),
            currency,
            country,
            onAuthorized
        };
    }, [
        cart,
        country,
        currency,
        locale,
        onAuthorized
    ]);
    const { expressGooglePayConfig  } = Hooks.useGooglePayConfig(googlePayConfigProps);
    const handleGooglePayPayment = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*(config) {
            if (!checkout) {
                return;
            }
            try {
                const googlePayCheckout = yield checkout;
                if (!googlePayCheckout) {
                    console.error('Checkout object is not initialized.');
                    return;
                }
                const googlePayComponent = googlePayCheckout.create('googlepay', config);
                if (!googlePayComponent) {
                    console.error('Failed to create Google Pay component.');
                    return;
                }
                const { result  } = yield googlePayComponent.isReadyToPay();
                if (result) {
                    googlePayComponent.submit();
                } else {
                    console.warn('Google Pay is not available.');
                }
            } catch (error) {
                console.error('Error during Google Pay process:', error);
            }
        });
        return function(config) {
            return _ref.apply(this, arguments);
        };
    }(), [
        checkout
    ]);
    const payCartWithGooglePay = React.useCallback(()=>{
        if (error1 && error1 !== UseGooglePayError.UNSUPPORTED) {
            console.error('Google pay is not supported.');
            setError(UseGooglePayError.UNSUPPORTED);
            toast.failed(GooglePaySessionErrors.GooglePaySessionUnsupported);
            return;
        }
        const shippingMethod = shippingMethodRef.current;
        const shippingAddressRequired = shippingMethod === ShippingMethod.Delivery || shippingMethod === ShippingMethod.DeliveryExpress || shippingMethod === ShippingMethod.DeliveryPremium;
        const config = expressGooglePayConfig(shippingAddressRequired);
        handleGooglePayPayment(config).catch((error)=>console.error('Error loading Google Pay', error)
        );
    }, [
        error1,
        expressGooglePayConfig,
        handleGooglePayPayment
    ]);
    return [
        payCartWithGooglePay,
        {
            error: error1 || createOrderError,
            loading: createOrderLoading
        }, 
    ];
};

export { UseGooglePayError, useGooglePay };
//# sourceMappingURL=use-google-pay.js.map
